import { ref } from 'vue'

// GUARDIÃO: Eis a Variável Universal. Altere aqui e o sistema todo obedece.
const TAMANHO_PADRAO_SISTEMA = 25

export function usePaginacao (tamanhoInicial = null) {
  // 1. Cria o estado reativo padronizado
  const paginacao = ref({
    CurrentPage: 1,
    PageSize: tamanhoInicial || TAMANHO_PADRAO_SISTEMA,
    TotalPages: 0,
    TotalCount: 0,
    HasNext: false,
    HasPrevious: false
  })

  /**
   * 2. Injeta os parâmetros de paginação blindados na requisição
   * @param {number} pageNumber - A página que queremos buscar
   * @param {URLSearchParams} params - O objeto de parâmetros atual (opcional)
   */
  const injetarParametros = (pageNumber = 1, params = new URLSearchParams()) => {
    paginacao.value.CurrentPage = pageNumber
    params.append('pageNumber', pageNumber)
    // O Fallback fica escondido aqui, blindando a API de Erros 400
    params.append('pageSize', paginacao.value.PageSize || TAMANHO_PADRAO_SISTEMA)
    return params
  }

  /**
   * 3. Atualiza o estado lendo o cabeçalho retornado pelo C#
   * @param {Object} headers - O cabeçalho da resposta do Axios
   */
  const atualizarPaginacao = (headers) => {
    if (headers && headers['x-pagination']) {
      paginacao.value = JSON.parse(headers['x-pagination'])
    }
  }

  return {
    paginacao,
    injetarParametros,
    atualizarPaginacao
  }
}
